import { Fragment, useEffect, useState } from "react";
import useStyles from "./styles";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useHistory, useParams, withRouter } from "react-router-dom";
import { useAuth } from "oidc-react";

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const SendEmail = ({ ...props }: any) => {
    const MySwal = withReactContent(Swal)
    const { userId } = useParams<Record<string, string >>();
    const [email, setEmail] = useState("")
    var auth = useAuth();

    useEffect(() => {
        getEmail()
    }, [userId])

    const getEmail = async () => {
        const response = await fetch(`/api/user/get/${userId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth?.userData?.access_token,
            },
            credentials: "include",
        });

        const data = await response.json()

        setEmail(data.email)
    }

    const sendEmail = async () => {
        const response = await fetch(`/api/user/forgotpassword/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth?.userData?.access_token,
            },
            credentials: "include",
            body: JSON.stringify(email),
        });

        if (response.status == 200) {

            await MySwal.fire({
                title: <strong>Correo enviado!</strong>,
                html: <i>Se ha enviado el email de manera satisfactoria!</i>,
                icon: 'success'
              })

            history.push("/user/create");
        }
    };

    const history = useHistory();

    var classes = useStyles();

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <PersonAddOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Enviar Email
            </Typography>
            <form className={classes.form}>
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={(e: any) => sendEmail()}
                    >
                        Enviar Email de Contraseña
                    </Button>
            </form>
        </Fragment>
    );
};

export default withRouter(SendEmail);
